/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Payment_ProformaInputs */

const en_reference_payment_proforma = /** @type {(inputs: Reference_Payment_ProformaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proforma`)
};

/**
* | output |
* | --- |
* | "Proforma" |
*
* @param {Reference_Payment_ProformaInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_payment_proforma = /** @type {((inputs?: Reference_Payment_ProformaInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Payment_ProformaInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_payment_proforma(inputs)
});